import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BoxscoreModel } from '../models/Boxscore';
import { Observable } from 'rxjs';
import { PlaybyplayModel } from '../models/Playbyplay';
import { ScoreboardModel } from '../models/Scoreboard';

@Injectable({
  providedIn: 'root'
})
export class GameService {
  constructor(private http: HttpClient) {  

  }
  public getGamesByDate(date:Date, isMonth = false, extraDays = 2){
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear();
    const dateText =  isMonth ? year + '-' + month : year + '-' + month + '-' + day;
    return this.http.get(environment.urlApiLmpRest + 'calendar?date=' + dateText + '&extraDays=' + extraDays).pipe( map( resp => {return resp;}));
  }

  public getScoreboard(date:Date):Observable<ScoreboardModel[]>{
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const year = date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear();
    const dateText =  year + '/' + month + '/' + day;
    return this.http.get(environment.urlApiLmpRest + '/scoreboard/' + dateText).pipe( map( (resp:any) => {
      return resp.response.filter( (p: any) => {
        return p.gameTime !== 'No Hay Juegos';
      }).map( (p: any) => {
        return new ScoreboardModel(p, date);
      });
    }));
  }

  getGameById(id: string): Observable<BoxscoreModel>{
    return this.http.get(`${environment.urlApiLmpRest}boxscore/${id}`).pipe(map<any, any>(resp => {
      return new BoxscoreModel(resp.response);
    }));
  }

  getGamePlaybyPlayById(id: string): Observable<PlaybyplayModel[]>{
    return this.http.get(`${environment.urlApiLmpRest}playbyplay/${id}`).pipe(map<any, any>(resp => {
      return resp.response.map((i:any) => new PlaybyplayModel(i));
    }));
  }

}
